import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminStpEditStateService {
  private readonly adminBasicProfileSubject = new BehaviorSubject<any>(null);
  readonly adminBasicProfile$ = this.adminBasicProfileSubject.asObservable();
  private readonly adminTrainerEditingSubject = new BehaviorSubject<any>(null);
  readonly adminTrainerEditing$ = this.adminTrainerEditingSubject.asObservable();
  private readonly adminStaffEditingSubject = new BehaviorSubject<any>(null);
  readonly adminStaffEditing$ = this.adminStaffEditingSubject.asObservable();
  private readonly adminToolsEditingSubject = new BehaviorSubject<any>(null);
  readonly adminToolsEditing$ = this.adminToolsEditingSubject.asObservable();
  private readonly adminFurnitureEditingSubject = new BehaviorSubject<any>(null);
  readonly adminFurnitureEditing$ = this.adminFurnitureEditingSubject.asObservable();

  setAdminBasicProfile(data: any): void {
    this.adminBasicProfileSubject.next(data);
  }

  getAdminBasicProfile(): any {
    return this.adminBasicProfileSubject.value;
  }

  startEditingTrainer(item: any): void {
    this.adminTrainerEditingSubject.next(item);
  }

  clearEditingTrainer(): void {
    this.adminTrainerEditingSubject.next(null);
  }

  startEditingStaff(item: any): void {
    this.adminStaffEditingSubject.next(item);
  }

  clearEditingStaff(): void {
    this.adminStaffEditingSubject.next(null);
  }

  startEditingTools(item: any): void {
    this.adminToolsEditingSubject.next(item);
  }

  clearEditingTools(): void {
    this.adminToolsEditingSubject.next(null);
  }

  startEditingFurniture(item: any): void {
    this.adminFurnitureEditingSubject.next(item);
  }

  clearEditingFurniture(): void {
    this.adminFurnitureEditingSubject.next(null);
  }

  updateCollectionItem(collectionKeys: string[], updatedItem: any): void {
    const currentData = this.getAdminBasicProfile();
    if (!currentData?.id && !updatedItem?.id && !currentData) {
      return;
    }

    const updatedData = { ...currentData };
    collectionKeys.forEach((key) => {
      if (!Array.isArray(updatedData[key])) {
        return;
      }

      updatedData[key] = updatedData[key].map((item: any) =>
        item?.id === updatedItem?.id ? { ...item, ...updatedItem } : item
      );
    });

    this.setAdminBasicProfile(updatedData);
  }

  addCollectionItem(collectionKeys: string[], newItem: any): void {
    const currentData = this.getAdminBasicProfile();
    if (!currentData) {
      return;
    }

    const updatedData = { ...currentData };
    collectionKeys.forEach((key) => {
      const existingItems = Array.isArray(updatedData[key]) ? updatedData[key] : [];
      updatedData[key] = [...existingItems, newItem];
    });

    this.setAdminBasicProfile(updatedData);
  }
}
